export default __webpack_public_path__ + "static/ocean-7626b12c95f79bcec913786ec6beef1e.jpg";